import { useQueryClient } from '@tanstack/react-query';
import useApiMutation from '_api/mutations/useApiMutation';
import { GET_ALL_ENCOUNTERS_KEY, GET_ENCOUNTER_BY_ID_KEY } from '_api/queries/encounter';
import { Encounter, EncounterPayload } from '_api/types';

export const UPDATE_ENCOUNTER_KEY = 'update-encounter';

export const useUpdateEncounter = () => {
  const queryClient = useQueryClient();
  return useApiMutation<Encounter, EncounterPayload>(
    () => '/encounter/update-encounter',
    'put',
    {},
    {
      mutationKey: [UPDATE_ENCOUNTER_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ENCOUNTERS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ENCOUNTER_BY_ID_KEY] });
      },
    },
  );
};
